<img class="c-image-container__image" src="/images/placeholder-login.png" alt="Image of an ink blob">
